/* Kuk ortak yardımcıları: fiyat biçimi, metin doldurma, kaçış, ölçüm olayı, sayfa kilidi, alt sayfa (sözlük
   bicim.altSayfa) ve aşağı sürükleyerek kapatma. Her sayfada yüklenir (layout/theme.liquid); ürün, koleksiyon ve
   sepet betikleri window.kukOrtak üzerinden kullanır. */
(() => {
  if (window.kukOrtak) return;

  const azHareket = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const kaydirma = () => (azHareket() ? 'auto' : 'smooth');

  // snippets/kuk-para.liquid ile aynı kural: '1.249,90 TL'
  const para = (kurus) => {
    const k = Math.round(Number(kurus) || 0);
    const lira = String(Math.floor(k / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `${lira},${String(k % 100).padStart(2, '0')} TL`;
  };
  const doldur = (metin, degerler) => String(metin).replace(/\[(\w+)\]/g, (_, k) => (degerler[k] ?? ''));
  const kacis = (metin) => String(metin ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  // Ölçüm olayı: GA4 ve Meta bağlantısı ölçüm adımında bu olayı dinler
  const olay = (ad, ayrinti) => document.dispatchEvent(new CustomEvent('kuk:olay', { detail: { ad, ...ayrinti } }));

  // Katman açıkken arka sayfa kaymaz; menü de aynı sınıfı kullanır (sections/kuk-baslik.liquid).
  // Sayaçlı: sepet çekmecesinin üstünde açılan alt sayfa kapanınca kilit çekmece için sürer
  let kilitSayisi = 0;
  const kilit = {
    ac() { kilitSayisi += 1; document.documentElement.classList.add('kuk-kaydirma-kilitli'); },
    kapat() {
      kilitSayisi = Math.max(0, kilitSayisi - 1);
      if (!kilitSayisi) document.documentElement.classList.remove('kuk-kaydirma-kilitli');
    },
  };

  // Aşağı sürükleyerek kapatma (alt sayfa ve görüntüleyici)
  const surukleKapat = (kutu, kapat, izin = () => true) => {
    let y0 = null;
    let x0 = 0;
    let dy = 0;
    kutu.addEventListener('touchstart', (e) => {
      if (!izin() || e.touches.length > 1) { y0 = null; return; }
      y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; dy = 0;
    }, { passive: true });
    kutu.addEventListener('touchmove', (e) => {
      if (y0 === null || e.touches.length > 1) return;
      const yeniDy = e.touches[0].clientY - y0;
      const dx = Math.abs(e.touches[0].clientX - x0);
      if (yeniDy > 0 && yeniDy > dx && (kutu.scrollTop || 0) <= 0) {
        dy = yeniDy;
        kutu.style.transform = `translateY(${dy}px)`;
      }
    }, { passive: true });
    kutu.addEventListener('touchend', () => {
      if (y0 === null) return;
      kutu.style.transform = '';
      if (dy > 80) kapat();
      y0 = null;
    });
  };

  /* Alt sayfa: X, arka plana dokunma, aşağı sürükleme, Escape ya da Android geri tuşu kapatır */
  const altSayfa = {
    ac(dialog) {
      if (!dialog || dialog.open) return;
      if (!dialog.dataset.hazir) {
        dialog.dataset.hazir = '1';
        dialog.querySelectorAll('[data-alt-sayfa-kapat]').forEach((b) => b.addEventListener('click', () => dialog.close()));
        dialog.addEventListener('click', (e) => {
          if (e.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (e.clientY < r.top || e.clientY > r.bottom || e.clientX < r.left || e.clientX > r.right) dialog.close();
        });
        dialog.addEventListener('close', () => {
          kilit.kapat();
          if (window.history.state && window.history.state.kukAltSayfa) window.history.back();
        });
        surukleKapat(dialog, () => dialog.close());
      }
      dialog.showModal();
      kilit.ac();
      window.history.pushState({ ...(window.history.state || {}), kukAltSayfa: true }, '');
      const kapat = () => { if (dialog.open) { window.history.replaceState({ ...(window.history.state || {}), kukAltSayfa: false }, ''); dialog.close(); } };
      window.addEventListener('popstate', kapat, { once: true });
    },
  };

  // Sayfa tipi (ölçüm parametresi sayfa_tipi): şablon adının Türkçe kodu, bilgi sayfalarında sayfa handle'ı
  const SAYFA_TIPLERI = { index: 'ana-sayfa', product: 'urun', collection: 'koleksiyon', 'list-collections': 'koleksiyonlar', cart: 'sepet', search: 'arama', blog: 'blog', article: 'yazi', policy: 'politika', 404: '404', password: 'sifre' };
  const sayfaTipi = () => {
    const sablon = document.getElementById('MainContent')?.dataset.template || '';
    if (sablon === 'page') return window.location.pathname.split('/').filter(Boolean).pop() || 'sayfa';
    if (sablon.startsWith('customers/')) return 'hesap';
    return SAYFA_TIPLERI[sablon] || sablon;
  };

  // WhatsApp bağlantıları (snippets/kuk-whatsapp-baglanti.liquid): ölçüm olayı whatsapp_tik (kaynak, urun_id, sayfa_tipi)
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-kuk-whatsapp]');
    if (a) olay('whatsapp_tik', { kaynak: a.dataset.kukWhatsapp, urun_id: document.querySelector('kuk-urun[data-urun-id]')?.dataset.urunId, sayfa_tipi: sayfaTipi() });
  });

  /* Ölçüm köprüsü (kurulum-olcum-operasyon 10-11): Kuk özel olayları Shopify Customer Events'e yayınlanır; özel piksel
     'kuk-ozel-olaylar' (olcum/ozel-piksel.js, Shopify panelinde) GA4'e gönderir. Standart olaylar (sepete ekleme, ödeme,
     satın alma) kanal uygulamalarından gider, burada tekrar yayınlanmaz. Yalnız SOP'taki parametreler gider (+ sayfa_tipi);
     değerler ASCII, küçük harf, Türkçe karakter yok; evet/hayir. İzin Shopify'da: özel piksel 'Analitik gerekli', onay
     yoksa olay düşer. Shopify.analytics yoksa (tema dışı) sessizce geçilir. */
  const OZEL_OLAYLAR = {
    whatsapp_tik: ['kaynak', 'urun_id', 'sayfa_tipi'],
    gelince_haber_ver: ['urun_id', 'kanal'],
    arama_sonucsuz: ['terim'],
    cerez_tercihi: ['secim', 'analitik', 'pazarlama'],
  };
  const HARF = { ç: 'c', ğ: 'g', ı: 'i', ö: 'o', ş: 's', ü: 'u', â: 'a', î: 'i', û: 'u' };
  const ascii = (v) => {
    if (typeof v === 'boolean') return v ? 'evet' : 'hayir';
    return String(v).trim().toLocaleLowerCase('tr').replace(/[çğıöşüâîû]/g, (h) => HARF[h]).slice(0, 100);
  };
  document.addEventListener('kuk:olay', (e) => {
    const { ad, ...ayrinti } = e.detail || {};
    const izinli = OZEL_OLAYLAR[ad];
    if (!izinli) return;
    const veri = { sayfa_tipi: sayfaTipi(), ...ayrinti };
    const temiz = Object.fromEntries([...new Set([...izinli, 'sayfa_tipi'])].filter((k) => veri[k] != null && veri[k] !== '').map((k) => [k, ascii(veri[k])]));
    try { window.Shopify?.analytics?.publish?.(ad, temiz); } catch (hata) { /* ölçüm sayfayı kırmaz */ }
  });

  window.kukOrtak = { azHareket, kaydirma, para, doldur, kacis, olay, kilit, surukleKapat, altSayfa };
})();
